import { render, staticRenderFns } from "./HiYield.vue?vue&type=template&id=6a0478e2&scoped=true"
var script = {}
import style0 from "./HiYield.vue?vue&type=style&index=0&id=6a0478e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0478e2",
  null
  
)

export default component.exports